import React from 'react';

const StatsCard = ({ title, value, trend, trendType, icon, iconBg, borderColor }) => {
  const trendColors = {
    up: 'text-green-500',
    down: 'text-red-500'
  };

  const trendIcons = {
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down'
  };

  return (
    <div className={`stat-card bg-white rounded-xl shadow-sm p-6 border-l-4 ${borderColor}`}>
      <div className="flex justify-between items-start">
        <div>
          <p className="text-gray-500 text-sm">{title}</p>
          <h3 className="text-2xl font-bold text-gray-800 mt-1">{value}</h3>
          {trend && (
            <p className={`${trendColors[trendType]} text-xs mt-2`}>
              <i className={`${trendIcons[trendType]} mr-1`}></i> {trend}
            </p>
          )}
        </div>
        <div className={`${iconBg} p-3 rounded-lg`}>
          <i className={`${icon} text-xl`}></i>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;